import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/energyTransitionReduceCarbon/icon3_01.png'


const _hoisted_1 = /*#__PURE__*/_createStaticVNode("<div class=\"kv\"><div class=\"caption\"><h1>減碳的努力</h1></div></div><section class=\"sect1\"><div class=\"ctx\"><p>和平電力積極評估可替代煤炭的燃料，我們先想到了「天然氣」，但台灣東部並無天然氣管線且受限於地形、地震及颱風直撲的影響，設置天然氣接收站並發展燃氣發電非常困難。</p><p>和平電廠是燃煤電廠，在無法轉型為天然氣發電下，減碳的方式就必須從提升發電機組效率、尋找可替代煤炭的燃料著手。</p><br><br><div class=\"left\"><div class=\"sectTit\">解決都市垃圾問題<br>協同減少溫室氣體排放</div><p>遠古時代，人類燒木材、燒牛糞煮飯或取暖，拿單純的廢棄物當燃料，這就是最直接了當的「生質能」，而固體再生燃料則是將適燃的廢棄物，包括廢塑膠、廢木材、廢布料和分選後的垃圾，加以均質化、形成單一性質的燃料。我們在思考利用生質能（木質顆粒）、固體再生燃料（SRF）等來替代部分煤源。</p><p>和平電力自 2021 年開始陸續委託 RWE、中興大學教授、Valmet……等國內外多家專業單位，針對各類可替代的燃料包含混參比例、燃燒模擬、運輸、防火防爆、安全貯存及輸運等進行評估，確保在整體系統安全穩定下使用，並作為未來投入改造的依據。</p></div><div class=\"right\"><div class=\"imgContainer1-1\"></div></div><div class=\"clear\"></div></div></section>", 2)
const _hoisted_3 = { class: "sect2" }
const _hoisted_4 = { class: "ctx" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sectTit" }, [
  /*#__PURE__*/_createTextVNode("提升發電效能 "),
  /*#__PURE__*/_createElementVNode("span", { class: "phoneBreak" }, "低壓汽輪機改造計畫")
], -1)
const _hoisted_6 = /*#__PURE__*/_createStaticVNode("<section class=\"sect3\"><div class=\"ctx\"><div class=\"improve\"><div class=\"icon\"><img src=\"" + _imports_0 + "\"></div><div class=\"desp\"><div>和平電力投入了 9 億台幣進行「低壓汽輪機」改造計畫，分別在 2021 年及 2023 年改造了二號機、一號機的低壓汽輪機，強化熱能有效利用，這可提升發電效率約 1.66%，相當於單部機組提升12MW，兩部共等同節省約 5.8 萬噸用煤量，等效節省碳排放量 13.2 萬噸。</div><p>雖然投入龐大金額對照減碳數字看起來不夠突出，但對於和平電力來說，為了 1% 減碳我們都願意嘗試各種可能性去改善。</p></div><div class=\"spec\"><div class=\"imgContainer3-1\"></div></div></div></div></section>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("article", null, [
      _hoisted_1,
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_swiper, {
            modules: _ctx.modules,
            "slides-per-view": 1,
            "space-between": 1,
            autoplay: {delay:3000, disableOnInteraction:false},
            speed: 1000,
            loop: true,
            pagination: {clickable:true},
            onSwiper: _ctx.onSwiper,
            onSlideChange: _ctx.onSlideChange,
            class: "swiper"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_swiper_slide, { class: "cover cover1" }),
              _createVNode(_component_swiper_slide, { class: "cover cover2" }),
              _createVNode(_component_swiper_slide, { class: "cover cover3" })
            ]),
            _: 1
          }, 8, ["modules", "onSwiper", "onSlideChange"])
        ])
      ]),
      _hoisted_6
    ]),
    _createVNode(_component_Footer)
  ], 64))
}